import React, { ReactElement, useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import Event from "./components/Event";
import moment, { Moment } from "moment-timezone";
import { useSelector } from "react-redux";

enum EventDirectionType {
  Incoming = 0,
  Outgoing = 1,
}

const CabinetEvents = (): ReactElement => {
  const location = useLocation();
  const [tab, setTab] = useState(EventDirectionType.Incoming);
  const currentTimeRaw: number | void = useSelector(
    (state) => state.Main.Time.current
  );
  const currentTime: Moment = moment(currentTimeRaw).tz("Europe/Moscow");
  const incomingEventCounter = useSelector(
    (state) => state.User.Event.incomingCounter
  );

  const incomingWaiting = useSelector(
    (state: any) => state.User.Event.incomingWaiting
  );
  const incomingApproved = useSelector(
    (state: any) => state.User.Event.incomingApproved
  );
  const incomingDeclined = useSelector(
    (state: any) => state.User.Event.incomingDeclined
  );
  const outgoingWaiting = useSelector(
    (state: any) => state.User.Event.outgoingWaiting
  );
  const outgoingApproved = useSelector(
    (state: any) => state.User.Event.outgoingApproved
  );
  const outgoingDeclined = useSelector(
    (state: any) => state.User.Event.outgoingDeclined
  );

  useEffect(() => {
    Middleware.User.Event.list();
  }, []);

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    switch (tab) {
      case "incoming":
        setTab(EventDirectionType.Incoming);
        break;
      case "outgoing":
        setTab(EventDirectionType.Outgoing);
        break;
      default:
        setTab(EventDirectionType.Incoming);
    }
  }, [location]);

  return (
    <>
      <div className="cabinet-events">
        <div className="cabinet-events__header">
          <h1 className="cabinet-events__title">Запросы на встречу</h1>
          <div className="cabinet-events__today-day">
            Сегодня: {moment(currentTime).tz("Europe/Moscow").format("D MMMM")}
          </div>
          <div className="cabinet-events__today-time">
            <span>
              {moment(currentTime).tz("Europe/Moscow").format("HH:mm")} МСК
            </span>{" "}
            GMT +3
          </div>
          <Link
            to="/cabinet/events/calendar"
            className="cabinet-events__calendar-btn"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 0C12.163 0 12.7989 0.263392 13.2678 0.732233C13.7366 1.20107 14 1.83696 14 2.5V11.5C14 12.163 13.7366 12.7989 13.2678 13.2678C12.7989 13.7366 12.163 14 11.5 14H2.5C1.83696 14 1.20107 13.7366 0.732233 13.2678C0.263392 12.7989 0 12.163 0 11.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0H11.5ZM11.5 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V11.5C1 11.8978 1.15804 12.2794 1.43934 12.5607C1.72064 12.842 2.10218 13 2.5 13H11.5C11.8978 13 12.2794 12.842 12.5607 12.5607C12.842 12.2794 13 11.8978 13 11.5V2.5C13 2.10218 12.842 1.72064 12.5607 1.43934C12.2794 1.15804 11.8978 1 11.5 1ZM4 8C4.26522 8 4.51957 8.10536 4.70711 8.29289C4.89464 8.48043 5 8.73478 5 9C5 9.26522 4.89464 9.51957 4.70711 9.70711C4.51957 9.89464 4.26522 10 4 10C3.73478 10 3.48043 9.89464 3.29289 9.70711C3.10536 9.51957 3 9.26522 3 9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8ZM7 8C7.26522 8 7.51957 8.10536 7.70711 8.29289C7.89464 8.48043 8 8.73478 8 9C8 9.26522 7.89464 9.51957 7.70711 9.70711C7.51957 9.89464 7.26522 10 7 10C6.73478 10 6.48043 9.89464 6.29289 9.70711C6.10536 9.51957 6 9.26522 6 9C6 8.73478 6.10536 8.48043 6.29289 8.29289C6.48043 8.10536 6.73478 8 7 8ZM4 4C4.26522 4 4.51957 4.10536 4.70711 4.29289C4.89464 4.48043 5 4.73478 5 5C5 5.26522 4.89464 5.51957 4.70711 5.70711C4.51957 5.89464 4.26522 6 4 6C3.73478 6 3.48043 5.89464 3.29289 5.70711C3.10536 5.51957 3 5.26522 3 5C3 4.73478 3.10536 4.48043 3.29289 4.29289C3.48043 4.10536 3.73478 4 4 4ZM7 4C7.26522 4 7.51957 4.10536 7.70711 4.29289C7.89464 4.48043 8 4.73478 8 5C8 5.26522 7.89464 5.51957 7.70711 5.70711C7.51957 5.89464 7.26522 6 7 6C6.73478 6 6.48043 5.89464 6.29289 5.70711C6.10536 5.51957 6 5.26522 6 5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4ZM10 4C10.2652 4 10.5196 4.10536 10.7071 4.29289C10.8946 4.48043 11 4.73478 11 5C11 5.26522 10.8946 5.51957 10.7071 5.70711C10.5196 5.89464 10.2652 6 10 6C9.73478 6 9.48043 5.89464 9.29289 5.70711C9.10536 5.51957 9 5.26522 9 5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4Z"
                fill="white"
              />
            </svg>
            Календарь
          </Link>
        </div>
        <div className="cabinet-events__main">
          <div className="cabinet-events__tabs">
            <div className="cabinet-events__tabs-header">
              <Link
                to="?tab=incoming"
                className={`cabinet-events__tabs-btn ${
                  tab === EventDirectionType.Incoming
                    ? "cabinet-events__tabs-btn--active"
                    : ""
                }`}
              >
                Входящие{" "}
                {incomingEventCounter !== null && incomingEventCounter > 0 ? (
                  <span>+{incomingEventCounter}</span>
                ) : (
                  <></>
                )}
              </Link>
              <Link
                to="?tab=outgoing"
                className={`cabinet-events__tabs-btn ${
                  tab === EventDirectionType.Outgoing
                    ? "cabinet-events__tabs-btn--active"
                    : ""
                }`}
              >
                Исходящие
              </Link>
              <Link
                to="/networking"
                className="cabinet-events__tabs-btn cabinet-events__tabs-btn--event-create"
              >
                Назначить встречу
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.5 0C7.89782 0 8.27936 0.158036 8.56066 0.43934C8.84197 0.720645 9 1.10218 9 1.5V6H13.5C13.8978 6 14.2794 6.15804 14.5607 6.43934C14.842 6.72064 15 7.10218 15 7.5C15 7.89782 14.842 8.27936 14.5607 8.56066C14.2794 8.84197 13.8978 9 13.5 9H9V13.5C9 13.8978 8.84197 14.2794 8.56066 14.5607C8.27936 14.842 7.89782 15 7.5 15C7.10218 15 6.72064 14.842 6.43934 14.5607C6.15804 14.2794 6 13.8978 6 13.5V9H1.5C1.10218 9 0.720645 8.84197 0.43934 8.56066C0.158036 8.27936 0 7.89782 0 7.5C0 7.10218 0.158036 6.72064 0.43934 6.43934C0.720645 6.15804 1.10218 6 1.5 6H6V1.5C6 1.10218 6.15804 0.720645 6.43934 0.43934C6.72064 0.158036 7.10218 0 7.5 0Z"
                    fill="#ff0011"
                  />
                </svg>
              </Link>
            </div>

            <div className="cabinet-events__tabs-body">
              {tab === EventDirectionType.Incoming ? (
                <>
                  {incomingWaiting?.length > 0 ? (
                    <div className="cabinet-events__tabs-block cabinet-events__tabs-block--bordered">
                      <div className="cabinet-events__tabs-block-wrapper">
                        {incomingWaiting?.map((item: any, index: number) => {
                          return (
                            <>
                              <Event
                                key={item.id}
                                id={item.id}
                                owner={item.owner}
                                participantList={item.participantList}
                                startAt={item.startAt}
                                endAt={item.endAt}
                                isOwner={item.isOwner}
                                description={item.description}
                                eventType="incomingWaiting"
                              />
                            </>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {incomingApproved?.length > 0 ||
                  incomingDeclined.length > 0 ? (
                    <div className="cabinet-events__tabs-block">
                      {incomingApproved?.map((item: any, index: number) => {
                        return (
                          <>
                            {index > 0 ? <hr /> : <></>}
                            <Event
                              key={item.id}
                              id={item.id}
                              owner={item.owner}
                              participantList={item.participantList}
                              startAt={item.startAt}
                              endAt={item.endAt}
                              isOwner={item.isOwner}
                              description={item.description}
                              eventType="incomingApproved"
                            />
                          </>
                        );
                      })}
                      {incomingDeclined?.map((item: any, index: number) => {
                        return (
                          <>
                            {index > 0 ? <hr /> : <></>}
                            <Event
                              key={item.id}
                              id={item.id}
                              owner={item.owner}
                              participantList={item.participantList}
                              startAt={item.startAt}
                              endAt={item.endAt}
                              isOwner={item.isOwner}
                              description={item.description}
                              eventType="incomingDeclined"
                            />
                          </>
                        );
                      })}
                    </div>
                  ) : incomingWaiting?.length === 0 &&
                    incomingApproved?.length === 0 &&
                    incomingDeclined?.length === 0 ? (
                    <>
                      <div className="cabinet-events__tabs-block">
                        Пока приглашений нет
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <div className="cabinet-events__tabs-block">
                  {outgoingApproved?.map((item: any, index: number) => {
                    return (
                      <>
                        {index > 0 ? <hr /> : <></>}
                        <Event
                          key={item.id}
                          id={item.id}
                          owner={item.owner}
                          participantList={item.participantList}
                          startAt={item.startAt}
                          endAt={item.endAt}
                          isOwner={item.isOwner}
                          description={item.description}
                          eventType="outgoingApproved"
                        />
                      </>
                    );
                  })}
                  {outgoingWaiting?.map((item: any, index: number) => {
                    return (
                      <>
                        {index > 0 ? <hr /> : <></>}
                        <Event
                          key={item.id}
                          id={item.id}
                          owner={item.owner}
                          participantList={item.participantList}
                          startAt={item.startAt}
                          endAt={item.endAt}
                          isOwner={item.isOwner}
                          description={item.description}
                          eventType="outgoingWaiting"
                        />
                      </>
                    );
                  })}
                  {outgoingDeclined?.map((item: any, index: number) => {
                    return (
                      <>
                        {index > 0 ? <hr /> : <></>}
                        <Event
                          key={item.id}
                          id={item.id}
                          owner={item.owner}
                          participantList={item.participantList}
                          startAt={item.startAt}
                          endAt={item.endAt}
                          isOwner={item.isOwner}
                          description={item.description}
                          eventType="outgoingDeclined"
                        />
                      </>
                    );
                  })}
                  {outgoingWaiting?.length === 0 &&
                  outgoingApproved?.length === 0 &&
                  outgoingDeclined?.length === 0 ? (
                    <div className="cabinet-events__tabs-empty-text">
                      Пока тут ничего нет!{" "}
                      <Link to="/networking">
                        Отправьте приглашение на встречу
                      </Link>
                      , и оно появится в этом разделе.
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CabinetEvents;
